import { JobStatusLandingComponent } from './job-status-landing.component';

export const containers: any[] = [JobStatusLandingComponent];

export * from './job-status-landing.component';
